<template>
    <div
        style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;display: flex;flex-direction: column;background: #F5F5F5;">
        <div
            style="width: 100%;display: flex;align-items: center;padding-top: 20px;padding-bottom: 20px;background: white;">
            <img src="../assets/返回.png" style="width: 20px;height: 20px;margin:0 50px 0 10px;" alt="">
            <div style="flex: 1;font-weight: 700;font-size: large;">地址管理</div>
            <div @click="addAddress" style="width: 80px;">添加地址</div>
        </div>
        <div v-for="item, index in addressList" :key="index"
            style="display: flex;flex-direction: column;background: white;margin-top: 10px;padding: 10px;">
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <div style="display: flex;align-items: center;font-weight: 700;">
                    <div>{{ item.contact }}</div>
                    <div style="margin: 0 10px;height: 100%;">{{ item.phoneNumber }}</div>
                    <div v-show="defaultAddress == item.id">默认</div>
                </div>
                <img @click="goToEditAddress(item.id)" src="../assets/编辑.png" style="width: 30px;height: 30px;" alt="">
            </div>
            <div style="text-align: left;margin: 10px 0;border-bottom: solid grey 1px;padding-bottom: 10px;">{{
                item.location + (item.detailAddress==null?'':item.detailAddress) }}</div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <el-checkbox @input="selectDefaultAddress(index)" v-model="item.isDefault">设为默认地址</el-checkbox>
                <div style="color: red;user-select: none;cursor: pointer;" @click="deleteAddress(item.id)">删除</div>
            </div>
        </div>
         <div style="width: 100%;margin: 20px 0;" :style="{
            height: $store.state.indexBarHeight+10 + 'px'
        }">
            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
        </div>
    </div>
</template>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            addressList: [],
            defaultAddress: null
        }
    },
    async mounted() {
        await this.getAddressList()
    },
    watch: {
        async defaultAddress(newValue, oldValue) {

        }
    },
    methods: {
        async getDefaultAddress() {
            let res = await request({
                url: "/user/api/getDefaultAddress",
                method: "GET"
            })
            if (res.data.status == 200) {
                this.defaultAddress = res.data.data
                this.updateRender()
            }
        },
        async selectDefaultAddress(index) {
            this.defaultAddress = this.addressList[index].id
            let res = await request({
                url: "/user/api/updateDefaultAddress/" + this.defaultAddress,
                method: "POST"
            })
            if (res.data.status == 200) {
                this.updateRender()
            }
        },
        updateRender() {
            this.$forceUpdate()
            for (let index = 0; index < this.addressList.length; index++) {
                const element = this.addressList[index];
                element.isDefault = element.id == this.defaultAddress
                console.log(element.isDefault);

                if (element.isDefault) {
                    localStorage.setItem("selectedAddress", JSON.stringify(element))
                }
            }
        },
        goToEditAddress(id) {
            this.$store.state.addForm = {
                contact: null,
                sex: null,
                phoneNumber: null,
                location: null,
                detailAddress: null,
                type: null,
                lng: null,
                lat: null
            }
            this.$router.push({
                path: '/editAddress/' + id
            })
        },
        async deleteAddress(id) {
            let res = await request({
                url: "/address/api/deleteAddress/" + id,
                method: "DELETE"
            })
            if (res.data.status == 200) {
                this.getAddressList()
            }
        },
        async getAddressList() {
            let res = await request({
                url: "/address/api/getAddressList",
                method: "GET"
            })
            if (res.data.status == 200) {
                this.addressList = res.data.data
                this.getDefaultAddress()
            }
        },
        addAddress() {
            this.$store.state.addForm = {
                contact: null,
                sex: null,
                phoneNumber: null,
                location: null,
                detailAddress: null,
                type: null,
                lng: null,
                lat: null
            }
            this.$router.push({
                path: '/addAddress'
            })
        }
    }
}
</script>

<style></style>